module.exports = __webpack_public_path__ + "img/coaching.977297cc.svg";